(function ($) {
    'use strict';

    $(document).ready(function () {
        $(".menu .menu-item a[href='" + location.pathname + "']").addClass('active');
    });

})(jQuery);